import { RequestTypes, RequestSubtypes } from '../../../../Enums';

/**
 * @typedef {typeof import('../../../../Enums/RequestType').RequestTypes} IRequestTypes
 * @param {IRequestTypes} requestType
 * @returns {bool}
 */
export const hasAllowOverlapRule = (requestType) => [RequestTypes.toCover, RequestTypes.shiftSwap, RequestTypes.openShift].includes(requestType);

/**
 * @typedef {typeof import('../../../../Enums/RequestType').RequestTypes} IRequestTypes
 * @param {IRequestTypes} requestType
 * @returns {bool}
 */
export const hasValidatePaycodeOverlapRule = (requestType) => [RequestTypes.toCover, RequestTypes.shiftSwap, RequestTypes.openShift].includes(requestType);

/**
 * @typedef {typeof import('../../../../Enums/RequestSubtype').RequestSubtypes} IRequestSubTypes
 * @param {IRequestTypes} requestType
 * @param {IRequestSubTypes} requestSubtype
 * @returns {bool}
 */
export const hasTimeBeforeOrAfterShiftStartAllowedRule = (requestType, requestSubtype) => [RequestTypes.toCover, RequestTypes.shiftSwap].includes(requestType) ||
(RequestTypes.openShift === requestType && requestSubtype === RequestSubtypes.fill) ||
(RequestTypes.voluntaryTimeOff === requestType && requestSubtype === RequestSubtypes.fill);

/**
 * @typedef {typeof import('../../../../Enums/RequestType').RequestTypes} IRequestTypes
 * @param {IRequestTypes} requestType
 * @returns {bool}
 */
export const hasMultipleShiftOnSameDayRule = (requestType) => [RequestTypes.toCover, RequestTypes.shiftSwap, RequestTypes.openShift].includes(requestType);
